import { render, staticRenderFns } from "./trade-list.vue?vue&type=template&id=2a06c3a6&"
import script from "./trade-list.vue?vue&type=script&lang=js&"
export * from "./trade-list.vue?vue&type=script&lang=js&"
import style0 from "./trade-list.vue?vue&type=style&index=0&id=2a06c3a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports